import { render, staticRenderFns } from "./popup-wu-liao-choose-one.vue?vue&type=template&id=bd2d2bf4&scoped=true"
import script from "./popup-wu-liao-choose-one.vue?vue&type=script&lang=js"
export * from "./popup-wu-liao-choose-one.vue?vue&type=script&lang=js"
import style0 from "./popup-wu-liao-choose-one.vue?vue&type=style&index=0&id=bd2d2bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d2bf4",
  null
  
)

export default component.exports